module.exports = __webpack_public_path__ + "images/happy-filleddb27af8885e7cc3dd435ecf76d0a563c.svg";